import { render } from "./MinhasCoberturas.vue?vue&type=template&id=e4f086ec"
import script from "./MinhasCoberturas.vue?vue&type=script&lang=js"
export * from "./MinhasCoberturas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__